<template lang="pug">
  div(data-testid="openflag-view")
    span(v-if="value === app_flag.ON" data-testid="-data-openflag")
      i.fa.bcard-fa-person-public(data-testid="-icon")
      |
      |
      | 公開
    span(v-else-if="value === app_flag.OFF" data-testid="-data-openflag")
      i.fa.bcard-fa-person-private(data-testid="-icon")
      |
      |
      | 非公開
    span(v-else) ---
</template>

<script>
export default {
  name: 'OpenflagView',
  props: {
    /**
     * @param {String} value openflag
     */
    value: { type: String, required: true }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/molecules/OpenflagView.vue